module.exports = {
  content: {
    noProductsTip: "该分类没有品牌～",
    allbrands: "所有品牌",
    allproducts: "所有产品",
    brand: "品牌",
    condition: "等级",
    sorting: "排序",
    price: "价格",
    yourSearch: "你的搜索: ",
    favoriteBrand: "选择你喜爱的品牌",
    viewllBrands: "查看所有品牌",
    advancedOptions: "高级选项",
    searchContent: "请输入内容",
    noProductTitle: "该类别中没有产品。",
    noProductContent: `抱歉，该分类下没有商品，请耐心等待
    我们产品的改进。`,
    noSearchTitle: "没有您的搜索结果。",
    noSearchContent: `抱歉，未找到您搜索的相关内容。`,
    noShopTitle: "这家店什么都没有。",
    noShopContent: `回到首页浏览一下，那里的产品可能会让你满意。`,
    noResult: `<p>没有结果。<br />
    - 检查您的拼写是否有打字错误。<br />
    - 尝试使用简短的关键字进行搜索。<br />
    - 尝试搜索更一般的术语 - 然后您可以过滤搜索结果。</p>`
  }
}


// WEBPACK FOOTER //
// ./src/assets/lang/zh-cn/classify/index.js